import MDB from '../marketingdb'

const initPopovers = (context, opts) => MDB.initPopovers(context, opts);

export default initPopovers